<template>
  <canvas id="lwf-container" ref="canvas"></canvas>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from "vue";
import "@/lib/lwf.js";

const props = withDefaults(
  defineProps<{
    href: string;
    scene?: string;
  }>(),
  {
    scene: "ef_001",
  },
);

const canvas = ref(null);
const urlParts = new URL(props.href).href.split("/").filter(Boolean);
const filename = urlParts.pop();
const path = urlParts.join("/") + "/";

let cache;
let animation;
let currentTime;
let fromTime;

onMounted(async () => {
  LWF.useCanvasRenderer();
  cache = LWF.ResourceCache.get();

  cache.loadLWF({
    stage: canvas.value,
    href: filename,
    prefix: path,
    setBackgroundColor: "FF000000",
    additionalParams: {
      alpha: true,
      premultipliedAlpha: true,
    },
    worker: false,
    onload: onLwfLoaded,
  });
});

const onLwfLoaded = (lwf) => {
  lwf.rootMovie.attachMovie(props.scene, `${props.scene}_1`);
  lwf.rootMovie.moveTo(lwf.width / 2, lwf.height / 2);
  lwf.scaleForHeight(canvas.value.width, canvas.value.height);
  lwf.active = true;
  animation = lwf;

  play();
};

function play() {
  window.requestAnimationFrame(play);

  if (animation?.active) {
    animation.exec(tick());
    animation.render();
  }
}

function tick() {
  currentTime = Date.now() / 1000.0;
  const tick = currentTime - fromTime;
  fromTime = currentTime;

  return tick;
}

onUnmounted(() => {
  if (animation) {
    cache.unloadLWF(animation);
    animation = null;
  }
});
</script>

<style scoped></style>
